export default "__VITE_ASSET__BrB5FFOB__"